
import MGW_PL_White  from '../MGW_PL_White.png'

export default function Logo(){
    return <img src={MGW_PL_White} style={{width:"25vw", zIndex:500}}></img>
}